// Re-export the existing StudentAdmission component for the admission directory
import StudentAdmission from '../students/StudentAdmission';
export default StudentAdmission;